import React from "react"
import { CustomOperation, OrderState } from "lib/types/generated/graphql-types"
import { InfoBox, Label, StyledStatus } from "./OrderHeader.styled"

type Props = {
  states: OrderState[]
  operationType: CustomOperation
}

const OperationStatus = ({ operationType, states }: Props) => {
  const isCompensation = operationType === CustomOperation.Compensation
  const isDelivery = operationType === CustomOperation.Delivery
  const isRefund = operationType === CustomOperation.Refund
  const isRelease = operationType === CustomOperation.Release


  const getLabel = () => {
    if (isCompensation) return "Compensated"
    if (isDelivery) return "Delivered"
    if (isRefund) return "Refunded"
    if (isRelease) return "Released"
  }

  const getOperationStatus = () => {
    if (isCompensation) {
      if (states?.includes(OrderState.PartiallyCompensated)) return "In part"
      if (states?.includes(OrderState.FullyCompensated)) return "In full"
    }
    if (isDelivery) {
      if (states?.includes(OrderState.PartiallyDelivered)) return "In part"
      if (states?.includes(OrderState.FullyDelivered)) return "In full"
    }
    if (isRefund) {
      if (states?.includes(OrderState.PartiallyRefunded)) return "In part"
      if (states?.includes(OrderState.FullyRefunded)) return "In full"
    }
    if (isRelease) {
      if (states?.includes(OrderState.Released)) return "Released"
    }
    return undefined
  }

  return (
    <>
      {getOperationStatus() && (
        <InfoBox>
          <Label>{getLabel()}</Label> <StyledStatus status={getOperationStatus() ?? ""} />
        </InfoBox>
      )}
    </>
  )
}

export default OperationStatus
